module.exports = __webpack_public_path__ + "img/client3.572cc009.png";